const backdropSaturate = {
    name: "backdrop-saturate",
    path: "/backdrop-saturate",
    title: "backdrop-saturate",
    description: "Utilities for applying backdrop-saturate filter effects to element's backdrop:",
    value: {
        'backdrop-filter': {
            'backdrop-saturate-<number>': 'saturate(<number>%)'
        },
    },
    exampleData: [
        {
            "title": "backdrop-saturate-50, backdrop-saturate-100",
            "description": "to control an element's backdrop-saturate:",
            "moreDescription": "",
            "parentClass": "grid md:grid-columns-3 gap-10 !bg-none !border-0 pt-10",
            "example": {
                "element": "img",
                "src": [
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-saturate-0",
                        "text": "backdrop-saturate-0",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-saturate-50",
                        "text": "backdrop-saturate-50",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                    {
                        "src": "https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo",
                        "className": "object-cover size-full mx-auto rounded-lg ",
                        "divClass": "absolute inset-10 bg-color-white/30 rounded-lg  backdrop-saturate-200",
                        "text": "backdrop-saturate-200",
                        "textClass": "absolute whitespace-nowrap font-sans font-regular -top-7 left-1/2 -translate-x-1/2 text-color-gray-700 dark:text-color-gray-200 text-xs italic",

                    },
                ],
                "className": "relative",
                "code": `<img class="backdrop-saturate-0" src="/img/mountains.jpg" />
<img class="backdrop-saturate-25" src="/img/mountains.jpg" />
<img class="backdrop-saturate" src="/img/mountains.jpg" />`
            }
        }
    ]
};

export default backdropSaturate;